import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Copy, Smartphone } from "lucide-react";
import { toast } from "sonner";
import { useApi, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { OtpField } from "./OtpField";

export default function TwoFASetup({ email, onDone }) {
  const api = useApi();
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.post("/auth/2fa/setup").then((r) => setSetup(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [api]);

  const enable = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/2fa/enable", { code });
      toast.success("2FA ativado com sucesso");
      onDone(data.token);
    } catch (e) {
      toast.error(errMsg(e));
      setCode("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen" data-testid="twofa-setup-screen">
      <div className="card w-full max-w-lg fade-up">
        <p className="caption text-emerald-400">Passo obrigatório</p>
        <h1 className="mt-1 font-heading text-3xl font-extrabold">Ative o Google Authenticator</h1>
        <p className="mt-2 text-sm text-slate-400">Conta: {email}. Sem o 2FA ninguém acessa o painel, nem com sua senha.</p>
        <ol className="mt-6 space-y-5 text-sm text-slate-300">
          <li className="flex gap-3"><Smartphone size={18} className="mt-0.5 shrink-0 text-emerald-400" /> Abra o Google Authenticator e toque em “+” → “Ler código QR”.</li>
        </ol>
        <div className="mt-4 flex flex-col items-center gap-4 sm:flex-row sm:items-start">
          <div className="rounded-xl bg-white p-3" data-testid="twofa-qr-code">
            {setup ? <QRCodeSVG value={setup.otpauth_url} size={168} /> : <div className="h-[168px] w-[168px]" />}
          </div>
          <div className="min-w-0 flex-1">
            <p className="caption">Ou digite a chave manualmente</p>
            <div className="code-block mt-2 break-all" data-testid="twofa-secret-text">{setup?.secret || "..."}</div>
            <Button variant="ghost" size="sm" className="mt-2 text-slate-300" data-testid="twofa-copy-secret-button"
              onClick={() => { navigator.clipboard.writeText(setup?.secret || ""); toast.success("Chave copiada"); }}>
              <Copy size={14} className="mr-1" /> Copiar chave
            </Button>
          </div>
        </div>
        <div className="mt-6 space-y-3">
          <p className="caption">Digite o código de 6 dígitos exibido no app</p>
          <OtpField value={code} onChange={setCode} />
          <Button className="btn-primary w-full" disabled={busy || code.length !== 6 || !setup} onClick={enable} data-testid="enable-2fa-button">
            {busy ? "Verificando..." : "Ativar 2FA e entrar"}
          </Button>
        </div>
      </div>
    </div>
  );
}
